module.exports = __webpack_public_path__ + "pc/img/lottie.0a6685ad.png";